// components/ClipboardButton/ClipboardButton.js

import React, { useState } from 'react';

import Button from '../Button/Button';
import Tooltip from '../Tooltip/Tooltip';
import CopyClipboardOutlineIcon from '../Icons/CopyClipboardOutlineIcon';
import { theme } from '../../theme';

const ClipboardButton = ({
  text,
  tooltipText = "URL copiada",
  label,
  ...props
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Error al copiar la URL:", err);
    }
  };

  return (
    <Tooltip text={tooltipText} trigger="click">
      <Button size="l" sizeTablet="l" sizeMobile="m" onClick={handleCopy} {...props}>
        <CopyClipboardOutlineIcon height={16} width={16} fill={theme.colors.defaultStrong} />
        {label}
      </Button>
    </Tooltip>
  );
};

export default ClipboardButton;
